import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, CardView, rem } from 'design-system';
import Text from 'design-system/Text';
const NotificationsWalkthroughBubbleContent = ({ onPressDone }) => (<CardView withPadding noMarginTop noMarginBottom pointerEvents="auto">
      <Text Text-16 OffBlack style={styles.title}>
        All notifications are now interactive!
      </Text>
      <Text TextThin-14 Secondary style={styles.message}>
        Tap any notification to see the full details 🧸
      </Text>
      <Button brand small square hug title="Got it" onPress={onPressDone} containerStyle={styles.button}/>
    </CardView>);
const styles = StyleSheet.create({
    title: {
        marginBottom: rem(4),
    },
    message: {
        marginBottom: rem(16),
    },
    button: {
        alignSelf: 'flex-end',
    },
});
export default NotificationsWalkthroughBubbleContent;
